var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 41.98 41.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#4d9447;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 41.98,
    height: 41.98
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1200",
    "data-name": 1200
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21,42H20.8A21,21,0,0,1,6.28,6a21,21,0,0,1,29.55.13A20.81,20.81,0,0,1,42,21V21a4.13,4.13,0,0,1-1.33,3.05,4.29,4.29,0,0,1-3.19,1.15h-.39a6.43,6.43,0,0,0-6.42,6.42,2.62,2.62,0,0,0,0,.28,9.64,9.64,0,0,1-9.52,10ZM21,1.64A19.37,19.37,0,0,0,7.11,34.5a19.2,19.2,0,0,0,13.71,5.84h.31a7.83,7.83,0,0,0,5.68-2.47A8,8,0,0,0,29,32c0-.12,0-.23,0-.35a8.07,8.07,0,0,1,8.06-8.06l.49,0a2.63,2.63,0,0,0,2-.71A2.54,2.54,0,0,0,40.34,21v0A19.36,19.36,0,0,0,21,1.64Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.42,36.08a4.92,4.92,0,1,1,4.92-4.92,4.92,4.92,0,0,1-4.92,4.92Zm0-8.2a3.28,3.28,0,1,0,3.28,3.28,3.28,3.28,0,0,0-3.28-3.28Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.64,25.93A4.92,4.92,0,1,1,13.56,21a4.93,4.93,0,0,1-4.92,4.92Zm0-8.2A3.28,3.28,0,1,0,11.92,21a3.29,3.29,0,0,0-3.28-3.28Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.24,15.72a4.92,4.92,0,1,1,4.92-4.92,4.93,4.93,0,0,1-4.92,4.92Zm0-8.2a3.28,3.28,0,1,0,3.28,3.28,3.28,3.28,0,0,0-3.28-3.28Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.79,15.68a4.92,4.92,0,1,1,4.92-4.92,4.92,4.92,0,0,1-4.92,4.92Zm0-8.2a3.28,3.28,0,1,0,3.28,3.28,3.28,3.28,0,0,0-3.28-3.28Z",
    transform: "translate(0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.4eabc88110591cca779d531b8c345deb.svg";
export { ForwardRef as ReactComponent };